import { motion } from "framer-motion";
import Header from "@/components/echo/Header";
import Footer from "@/components/echo/Footer";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function LegalPageLayout({ title, subtitle, children, testid }) {
  return (
    <div className="echo-bg min-h-screen relative" data-testid={testid}>
      <div className="noise-overlay" aria-hidden="true" />
      <div className="relative z-10 flex flex-col min-h-screen">
        <Header />
        <main className="flex-1 pt-32 sm:pt-40 pb-16">
          <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors duration-300 mb-8 font-medium"
                data-testid="legal-back-link"
              >
                <ArrowLeft className="w-4 h-4" />
                Retour à l&apos;accueil
              </Link>

              <h1
                data-testid="legal-title"
                className="text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tight text-white leading-[1.05] mb-4"
              >
                {title}
              </h1>
              {subtitle && (
                <p className="text-lg text-white/60 font-medium mb-12" data-testid="legal-subtitle">
                  {subtitle}
                </p>
              )}

              <article className="prose-echo space-y-8" data-testid="legal-content">
                {children}
              </article>
            </motion.div>
          </div>
        </main>
        <Footer />
      </div>

      <style>{`
        .prose-echo h2 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #fff;
          margin-top: 2rem;
          margin-bottom: 0.75rem;
          letter-spacing: -0.02em;
        }
        .prose-echo h3 {
          font-size: 1.125rem;
          font-weight: 600;
          color: #fff;
          margin-top: 1.5rem;
          margin-bottom: 0.5rem;
        }
        .prose-echo p {
          color: rgba(255, 255, 255, 0.7);
          font-size: 1rem;
          line-height: 1.7;
          font-weight: 400;
        }
        .prose-echo ul {
          list-style: disc;
          padding-left: 1.5rem;
          color: rgba(255, 255, 255, 0.7);
          line-height: 1.7;
        }
        .prose-echo li {
          margin-bottom: 0.5rem;
        }
        .prose-echo a {
          color: #B47CE8;
          text-decoration: underline;
          text-decoration-color: rgba(180, 124, 232, 0.4);
          transition: text-decoration-color 0.2s;
        }
        .prose-echo a:hover {
          text-decoration-color: rgba(180, 124, 232, 1);
        }
        .prose-echo strong {
          color: #fff;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}
